import type {
  ObservabilityConfigInput,
  SailObservabilityConfig,
} from 'src/types';

export default function createObservabilityConfig(
  input: ObservabilityConfigInput,
): SailObservabilityConfig {
  // Introduce compile-time-only brands without changing the supplied value.
  return input as SailObservabilityConfig;
}
